export default {"src":"//tokenlon.im/_next/static/media/mascot-normal.83747d57.gif","height":200,"width":200};